/* eslint-disable react/no-array-index-key */
import { Text, View } from '@react-pdf/renderer';
import styles, { borderStyles } from '../pro-report-pdf-styles';
import {
  SecurityThreat,
  SecurityThreatTrend,
  translateThreatLevelToText,
  translateThreatLevelToColour,
  translateThreatTrendToText,
  translateThreatTrendToColor,
} from '../../../models/pro.model';

/* PDF-specific method for best visibility */
const translateThreatTrendToIcon = (threatTrend: SecurityThreatTrend) => {
  switch (threatTrend) {
    case SecurityThreatTrend.UNCHANGED:
      return '→';
    case SecurityThreatTrend.UP:
      return '↑';
    case SecurityThreatTrend.DOWN:
      return '↓';
    default:
      return '';
  }
};

interface ThreatTableProps {
  threats: SecurityThreat[];
}

function ThreatTable({ threats }: ThreatTableProps) {
  if (!threats || threats.length === 0) return null;

  return (
    <View wrap={false} style={styles.table}>
      <View style={styles.vesselDetailsTableHeader}>
        <Text
          style={{
            ...styles.vesselDetailsTableCell,
            ...borderStyles,
            borderRight: '1px',
            width: '40%',
          }}
        >
          Threat
        </Text>
        <Text
          style={{
            ...styles.vesselDetailsTableCell,
            ...borderStyles,
            borderRight: '1px',
            width: '30%',
            flexGrow: 1,
          }}
        >
          Level
        </Text>
        <Text
          style={{
            ...styles.vesselDetailsTableCell,
            ...borderStyles,
            borderRight: '1px',
            width: '30%',
            flexGrow: 1,
          }}
        >
          Trend
        </Text>
      </View>
      {threats.map((threat) => (
        <View style={styles.vesselDetailsTableRow} key={threat.type}>
          <Text
            style={{
              ...styles.vesselDetailsTableCell,
              ...borderStyles,
              borderRight: '1px',
              width: '40%',
            }}
          >
            {threat.type}
          </Text>
          <Text
            style={{
              ...styles.vesselDetailsTableCell,
              ...borderStyles,
              borderRight: '1px',
              width: '30%',
              flexGrow: 1,
              color: translateThreatLevelToColour(threat.level),
              fontWeight: 700,
            }}
          >
            {translateThreatLevelToText(threat.level)}
          </Text>
          <Text
            style={{
              ...styles.vesselDetailsTableCell,
              ...borderStyles,
              borderRight: '1px',
              width: '30%',
              flexGrow: 1,
              justifyContent: 'center',
              alignItems: 'center',
              color: translateThreatTrendToColor(threat.trend),
            }}
          >
            {translateThreatTrendToText(threat.trend)}{' '}
            <Text
              style={{
                fontFamily: 'Urbanist',
                color: translateThreatTrendToColor(threat.trend),
              }}
            >
              {translateThreatTrendToIcon(threat.trend)}
            </Text>
          </Text>
        </View>
      ))}
    </View>
  );
}

export default ThreatTable;
